<script lang="ts">
  import { xhr, toast, formatDate } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let {
    responses,
    type
  }: {
    responses: AlignmentTestResponseType[]
    type: string
  } = props

  async function resendInvitation(response) {
    try {
      const resp = await xhr.patch(
        `/plans/${appStore.plan.id}/alignment_tests/${response.id}/resend_invitation`,
        {}
      )

      let updated_response = resp.data.alignment_test_response

      let foundIndex = responses.findIndex((t) => t.id == updated_response.id)
      responses[foundIndex] = updated_response
      toast("Invitation email re-sent", "success")
    } catch (e) {
      console.log(e)
      toast(
        "There was an error resending the alignment test invitation",
        "error"
      )
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
    }
  }
</script>

<ul class="py-6">
  {#each responses.filter((r) => r.test_type === type) as response (response.id)}
    <li class="max-w-2xl mx-auto grid grid-cols-4 items-center py-2 px-4">
      <div class="flex items-center justify-start">
        <img
          src={response.user.avatar_thumb_url}
          class="w-8 h-8 rounded-lg"
          alt={response.user.name}
        />
        <span class="text-gray-600 ml-2">{response.user.name}</span>
      </div>
      <div>
        {#if response.status == "in_progress"}
          <div
            class="ml-2 inline-flex items-center rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-600/20"
          >
            Step {response.current_step}
          </div>
        {:else if response.status == "invited"}
          <div
            class="ml-2 inline-flex items-center rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-600/20"
          >
            Invite sent {formatDate(response.invitation_sent_at)}
          </div>
        {/if}
      </div>
      <div class="flex justify-center">
        <div
          class="ml-2 inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-teal-800 ring-1 ring-inset ring-teal-600/20"
        >
          {response.status_title}
        </div>
      </div>
      <div class="flex justify-center">
        {#if response.status !== "complete"}
          <button
            onclick={() => resendInvitation(response)}
            class="text-sm text-blue-700 hover:text-blue-800 underline hover:bg-blue-100 px-2 py-1.5 border border-blue-100"
            >Resend Invite Email</button
          >
        {/if}
      </div>
    </li>
  {/each}
</ul>
